export default class TransactionFieldsToEdit {
  static REASON = "reason";

  static ADDRESS = "address";

  static VENDOR_ID = "vendorId";

  static CATEGORY = "category";

  static ITEM = "item";

  static LOCATION = "location";

  static PROJECT = "project";

  static TAX_RATE = "taxRate";

  static CLASS = "class";

  static TAGS = "tags";
}
